import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }

import { computed, Ref, ref, toRef } from 'vue';
import Chip from 'primevue/chip';
import { useToast } from 'primevue/usetoast';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { EMIT, PERMISSIONS } from '@/enum';
import { can } from '@/composables';
import { StudentFacilitatorInterface } from '@/types/Student';
import { useStudentFacilitatorStore } from '@/store';
import router from '@/router';

interface FacilitatorPropsInterface {
  tableData?: StudentFacilitatorInterface[];
  studentId?: number | undefined;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentFacilitatorTable',
  props: {
    tableData: {},
    studentId: {},
    loading: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const facilitatorCount: Ref<number> = computed(() => (facilitators.value ? facilitators.value.length : 0));
const facilitators: Ref<StudentFacilitatorInterface[] | undefined> = toRef(props, 'tableData');
const facilitatorsItems: Ref<{ name: string; value: number }[]> = ref([]);
const isAttach = ref(false);
const isModalOpen = ref(false);
const studentFacilitatorStore = useStudentFacilitatorStore();
const toast = useToast();

const doMessage = (name: string) => {
  toast.add({
    severity: 'success',
    summary: isAttach.value ? 'Added' : 'Removed',
    detail: isAttach.value ? 'Facilitator(s) has been added' : `Facilitator ${name} has been removed from student`,
    life: 3000,
  });
  emit(EMIT.UPDATE);
};

const attachFacilitators: (ids: number[]) => Promise<void> = async (ids) => {
  await studentFacilitatorStore.attachFacilitators({ facilitators: ids, studentId: props.studentId as number });

  isAttach.value = !isAttach.value;

  doMessage('');
};

const onCancel = () => {
  isModalOpen.value = !isModalOpen.value;
};

const openAddFacilitators = async () => {
  if (can([PERMISSIONS.STUDENT_ATTACH_FACILITATORS]) && can([PERMISSIONS.STUDENT_FACILITATORS_AVAILABLE_TO_ADD])) {
    facilitatorsItems.value = await studentFacilitatorStore.getAddFacilitatorsModalData(props.studentId as number);
    isModalOpen.value = !isModalOpen.value;
  } else {
    toast.add({
      severity: 'warning',
      summary: 'Error',
      detail: 'You do not have permission to add facilitators',
      life: 3000,
    });
  }
};

const onSave = (facilitators: { name: string; value: number }[]) => {
  const facilitatorIds = facilitators.map((facilitator) => facilitator.value);
  attachFacilitators(facilitatorIds);
  isModalOpen.value = !isModalOpen.value;
};

const detachFacilitator: (ids: number[], facilitatorName: string) => Promise<void> = async (ids, facilitatorName) => {
  await studentFacilitatorStore.detachFacilitators({ facilitatorsIds: ids, studentId: props.studentId as number });

  isAttach.value = false;

  doMessage(facilitatorName);
};

const createMenuModel = (item: { id: number; display_name: string }) => {
  return [
    {
      label: 'Remove Facilitator',
      command: () => {
        detachFacilitator([item.id], item.display_name);
      },
      visible: can([PERMISSIONS.STUDENT_DETACH_FACILITATORS]),
    },
    {
      label: 'View Profile',
      command: () => {
        router.push(`/user/${item.id}`);
      },
      visible: can([PERMISSIONS.STUDENT_FACILITATORS_SHOW]),
    },
  ].filter((item) => item.visible);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Facilitators", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(facilitatorCount.value), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).STUDENT_ATTACH_FACILITATORS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "text",
              size: "small",
              text: "Add Facilitator",
              "icon-left": "add",
              onClick: openAddFacilitators
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: facilitators.value,
        "global-filter-fields": ['name'],
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: __props.loading,
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-student-facilitator-store-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': __props.loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Facilitators not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (facilitatorCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, {
                  "body-class": "mw-20rem",
                  "header-class": "mw-20rem",
                  field: "name",
                  header: "Facilitator"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_RouterLink, {
                      to: `/user/${data.id}`,
                      class: "font-semibold",
                      textContent: _toDisplayString(data.display_name)
                    }, null, 8, ["to", "textContent"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column),
                _createVNode(_component_Column, {
                  "body-style": "justify-content: center; max-width: 10rem;",
                  "header-style": "justify-content: center; max-width: 10rem",
                  field: "id",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    (createMenuModel(data).length > 0)
                      ? (_openBlock(), _createBlock(_component_ActionMenu, {
                          key: 0,
                          "menu-items": createMenuModel(data),
                          icon: "more_horiz"
                        }, null, 8, ["menu-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "class"]),
      (isModalOpen.value && _unref(can)([_unref(PERMISSIONS).STUDENT_FACILITATORS_AVAILABLE_TO_ADD]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add Facilitators",
            items: facilitatorsItems.value,
            searchable: true,
            "button-text": "Add Facilitators",
            placeholder: "Search Facilitators",
            "person-type": "facilitator",
            onAddItems: onSave,
            onCancel: onCancel
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})